const SUBMIT_BIT_STATUS_DETAIL = {
  SUCCESS: {
    theme: 'theme-blue',
    modalName: 'modals-submit-bid',
    bodyContent: 'body-content-submit',
    textTitle: 'Submit Bid',
    submitButton: true,
  },
  FAIL: {
    theme: 'theme-red',
    modalName: 'modals-submit-bid-fail',
    bodyContent: 'body-content-warning',
    textTitle: 'Submission Error!',
    submitButton: false,
  },
}
const SUBMIT_BIT_STATUS = {
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
}

const BIDDING_TYPE = {
  REVERSE: 'Reverse',
  FORWARD: 'Forward',
}

const SUBMIT_BID_STATUS_ID = {
  1: {
    header: '',
    detail: 'Your total bid amount is',
    subDetail: 'Do you confirm to submit bid?',
  },
  2: {
    header: 'Your bid amount must either be equivalent',
    detail: 'to or lower than opening price',
    subDetail: 'Please re-submit your bid.',
  },
  3: {
    header: 'Your bid amount must either be equivalent',
    detail: 'to or greater than opening price',
    subDetail: 'Please re-submit your bid.',
  },
  4: {
    header: 'Your bid amount must lower than',
    detail: 'leading bid',
    subDetail: 'Please re-submit your bid.',
  },
  5: {
    header: 'Your bid amount must be greater than ',
    detail: 'leading bid',
    subDetail: 'Please re-submit your bid.',
  },
  6: {
    header:
      'Your total bid amount must be decreased by a set of decrement each time.',
    detail: 'This event bid decrement is',
    subDetail: 'Please re-submit your bid.',
  },
  7: {
    header:
      'Your total bid amount must be increased by a set of increment each time.',
    detail: 'This event bid increment is',
    subDetail: 'Please re-submit your bid.',
  },
  8: {
    header: 'Your total bid amount must lower than',
    detail: 'minimum bid decrement',
    subDetail: 'Please re-submit your bid.',
  },
  9: {
    header: 'Your total bid amount must be greater than',
    detail: 'minimum bid increment',
    subDetail: 'Please re-submit your bid.',
  },
  // 10: {
  //   header: 'Your bid is rejected!',
  //   detail: 'You must submit bid no greater than 10 times of bid decrement',
  //   subDetail: 'Please re-submit your bid.',
  // },
  // 11: {
  //   header: 'Your bid is rejected!',
  //   detail: 'You must submit bid no greater than 10 times of bid increment',
  //   subDetail: 'Please re-submit your bid.',
  // },
  // 12: {
  //   header: 'Your bid is rejected!',
  //   detail:
  //     'You must submit bid no greater than 10 times of minimum bid decrement',
  //   subDetail: 'Please re-submit your bid.',
  // },
  // 13: {
  //   header: 'Your bid is rejected!',
  //   detail:
  //     'You must submit bid no greater than 10 times of minimum bid increment',
  //   subDetail: 'Please re-submit your bid.',
  // },
}

export let SubmitBid = {
  ...SUBMIT_BIT_STATUS_DETAIL,
  ...SUBMIT_BID_STATUS_ID,
  SUBMIT_BIT_STATUS,
  BIDDING_TYPE,
}
